/**
 * Binding to `GET /api/referrals`. The Rust API resolves the viewer's FluxAccounts subject, calls
 * FluxAccounts, validates every link and computes `uses_left`; this module only moves the typed
 * answer into the Invite friends page.
 *
 * @module apps/web/src/lib/referralsApi
 */

import { request } from './api';

/** FluxAccounts public sign-up page; a referral or beta code is redeemed here. */
export const FLUXACCOUNTS_JOIN_URL = 'https://accounts.fluxability.io/join';

/** Sign-up mode FluxAccounts reports for its `/join` page. */
export type FluxAccountsSignupMode = 'invite_only' | 'open' | 'closed';

/** Referral summary returned by the API, already validated server-side. */
export interface ReferralSummary {
  /** Referral code to share, for example `FLUX-ABCD-EFGH`. */
  code: string;
  /** `https://accounts.fluxability.io/join…` link that pre-fills the code. */
  join_url: string;
  /** Successful sign-ups made with the code so far. */
  uses: number;
  /** Sign-ups the code allows in total. */
  max_uses: number;
  /** Sign-ups still available; never negative. */
  uses_left: number;
  /** Current FluxAccounts sign-up mode. */
  signup_mode: FluxAccountsSignupMode;
  /** Whether the viewer is a company member who may create beta codes. */
  can_create_beta_codes: boolean;
  /** FluxAccounts `/codes` page, present only when `can_create_beta_codes` is true. */
  beta_codes_url: string | null;
}

/** Referral endpoints used by the Invite friends page. */
export const referralsApi = {
  /** Load the signed-in person's referral summary. Failures arrive as a typed error envelope. */
  summary: () => request<ReferralSummary>('/referrals'),
};
